import React from "react";

export default function MSAccess_Split() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Split</h1>
      <p>This is the MSAccess_Split component generated from the SQL JSON.</p>
    </div>
  );
}
